import React, { useState } from "react";
import * as styles from "./Sort.module.scss";
import classNames from "classnames";
import Icon from "@app/components/Icon";
import PropTypes from "prop-types";

const Sort = ({ count, countLabel, label, desc = true, onClick, className }) => {
	const [isDesc, setIsDesc] = useState(desc);
	const SortClassName = classNames({
		[styles["sort"]]: true,
		[className]: !!className,
	});
	const iconAscClassName = classNames({
		[styles["icon-asc"]]: true,
		[styles.active]: !isDesc,
	});
	const iconDescClassName = classNames({
		[styles["icon-desc"]]: true,
		[styles.active]: isDesc,
	});

	const onDirectionChange = () => {
		if (onClick && typeof onClick === "function") {
			onClick(!isDesc);
		}
		setIsDesc(!isDesc);
	};

	return (
		<div className={SortClassName}>
			<div className={styles["count"]}>
				<span className={styles["count-number"]}>{count}</span> {countLabel}
			</div>
			<div className={styles["value"]} onClick={onDirectionChange}>
				<span>{label}</span>
				<div className={styles.icons}>
					<Icon icon={"sort"} className={iconAscClassName} />
					<Icon icon={"sort"} className={iconDescClassName} />
				</div>
			</div>
		</div>
	);
};

Sort.propTypes = {
	count: PropTypes.number,
	countLabel: PropTypes.string,
	label: PropTypes.string,
	desc: PropTypes.bool,
	onClick: PropTypes.func,
	className: PropTypes.string,
};

export default Sort;
